<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="ORIM-Book-Title--Front-Matter-" id="_idParaDest-1">Starfarers</p>
<p class="ORIM-Author-Name--Front-Matter-">Vonda N. McIntyre</p>
<div class="img_container1"> <img alt="image" src="images/logo.jpg"/> </div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Starfarers_1231.vue?76055d24